import { PriceObjectDtoSchema } from "@modules/common/priceObject/gateway/priceObjectApiDto"
import { ProgramOnOffPaymentDtoSchema } from "@modules/programs/gateway/programDto"
import { ProgramSubscriptionStatus } from "@modules/programs/types/programTypes"
import { z } from "zod"

export const StripeOnOffProgramSubscriptionDtoSchema = z
  .object({
    subscriptionId: z.string(),
    subscriptionStatus: z.enum(ProgramSubscriptionStatus),
    paidDate: z.string().nullable(),
    paidPrice: PriceObjectDtoSchema.nullable(),
    referencePrice: PriceObjectDtoSchema.nullable(),
    payment: ProgramOnOffPaymentDtoSchema.nullable(),
  })
  .meta({ id: "StripeOnOffProgramSubscriptionDtoSchema" })

export const OnOffSubscriptionDtoSchema = z
  .object({
    status: z.enum(ProgramSubscriptionStatus),
  })
  .meta({ id: "OnOffSubscriptionDtoSchema" })

export type StripeOnOffProgramSubscriptionDto = z.infer<typeof StripeOnOffProgramSubscriptionDtoSchema>
export type OnOffSubscriptionDto = z.infer<typeof OnOffSubscriptionDtoSchema>
